// Priorização do cliente na fila de atendimento.
//
// NOTA: ISTO É FALLBACK. O backend vai mandar `priority` pronto no payload — este
// módulo existe para rodar sobre mock enquanto isso e para dar ao servidor uma
// regra escrita e testável a reproduzir. `journey-adapters` só chama estas
// funções quando o campo NÃO veio: payload vence cálculo local, sempre.
import {
  PRIORITY,
  PRIORITY_THRESHOLDS,
  PRIORITY_WEIGHTS,
} from '@modules/client-journey/constants/Text'

const ETAPAS_DE_ENTRADA = new Set(['qualificacao', 'r1', 'r2'])

function pontosDeSla(slaOverdueDays) {
  const dias = Number(slaOverdueDays) || 0
  if (dias <= 0) return 0
  return Math.min(PRIORITY_WEIGHTS.SLA_TETO, dias * PRIORITY_WEIGHTS.SLA_POR_DIA)
}

function pontosDeInteracao(daysWithoutInteraction) {
  const dias = Number(daysWithoutInteraction) || 0
  const alem = Math.max(0, dias - PRIORITY_WEIGHTS.INTERACAO_CARENCIA_DIAS)
  return Math.min(
    PRIORITY_WEIGHTS.INTERACAO_TETO,
    alem * PRIORITY_WEIGHTS.INTERACAO_POR_DIA
  )
}

function pontosDeFase(currentStageId, inEntryPipeline) {
  const naEntrada =
    inEntryPipeline === undefined
      ? ETAPAS_DE_ENTRADA.has(currentStageId)
      : !!inEntryPipeline
  if (naEntrada) return PRIORITY_WEIGHTS.FASE_ENTRADA
  if (currentStageId === 'compliance') return PRIORITY_WEIGHTS.FASE_COMPLIANCE
  return PRIORITY_WEIGHTS.FASE_DEMAIS
}

function pontosDePatrimonio(patrimonio) {
  const valor = Number(patrimonio) || 0
  const faixa = PRIORITY_WEIGHTS.PATRIMONIO.find((f) => valor >= f.minimo)
  return faixa ? faixa.pontos : 0
}

export function calcularScore(signals, currentStageId) {
  const s = signals || {}
  return (
    pontosDeSla(s.slaOverdueDays) +
    pontosDeInteracao(s.daysWithoutInteraction) +
    pontosDeFase(currentStageId, s.inEntryPipeline) +
    pontosDePatrimonio(s.patrimonio)
  )
}

export function nivelDoScore(score) {
  const n = Number(score) || 0
  if (n >= PRIORITY_THRESHOLDS[PRIORITY.CRITICA]) return PRIORITY.CRITICA
  if (n >= PRIORITY_THRESHOLDS[PRIORITY.ALTA]) return PRIORITY.ALTA
  if (n >= PRIORITY_THRESHOLDS[PRIORITY.MEDIA]) return PRIORITY.MEDIA
  return PRIORITY.BAIXA
}

// Os motivos que a célula da lista mostra sob a barra. Ordem fixa (SLA →
// interação → contexto) porque é a ordem em que o profissional decide: prazo
// estourado manda mais que patrimônio alto.
export function montarMotivos(signals, currentStageId) {
  const s = signals || {}
  const motivos = []

  const atraso = Number(s.slaOverdueDays) || 0
  if (atraso > 0) {
    motivos.push(
      atraso === 1 ? 'SLA vencido há 1 dia' : `SLA vencido há ${atraso} dias`
    )
  }

  const semInteracao = Number(s.daysWithoutInteraction) || 0
  if (semInteracao > PRIORITY_WEIGHTS.INTERACAO_CARENCIA_DIAS) {
    motivos.push(`${semInteracao} dias sem interação`)
  }

  if (atraso <= 0 && semInteracao <= PRIORITY_WEIGHTS.INTERACAO_CARENCIA_DIAS) {
    if (currentStageId === 'compliance') motivos.push('Etapa regulatória em aberto')
    else if (pontosDePatrimonio(s.patrimonio) >= 15) motivos.push('Alto patrimônio')
  }

  return motivos
}

// Prioridade completa a partir dos sinais crus.
export function derivarPrioridade(signals, currentStageId) {
  const score = calcularScore(signals, currentStageId)
  return {
    level: nivelDoScore(score),
    score,
    reasons: montarMotivos(signals, currentStageId),
  }
}
